import React, { PureComponent } from 'react';
import Select from 'react-select';
import { connect } from 'shalala';

import { useStore } from '../../../../store';
import Loading from '../../../../facturotopia/loading/Loading';

class ClientePacSelection extends PureComponent {
  state = {
    selectedOptions: null,
  };

  get options() {
    const { data = [] } = this.props.list;

    const pacs = data.map((item) => {
      return {
        label: item.nombre,
        value: item.alias,
      };
    });

    return [
      {
        label: 'Todos',
        value: 'all',
      },
    ].concat(pacs);
  }

  componentDidMount() {
    const { data } = this.props;

    if (!data || data.length === 0) {
      this.props.listActions.paginate();
    }
  }

  componentDidUpdate() {
    if (this.props.pacs?.length > 0 && !this.state.selectedOptions) {
      this.setState({
        selectedOptions: this.props.pacs,
      });
    }
  }

  handleChange = (selectedOptions) => {
    this.setState({ selectedOptions });

    this.props.onChange(selectedOptions);
  };

  render() {
    const { selectedOptions } = this.state;
    const { busy } = this.props;

    if (busy) {
      return <Loading />;
    }

    return (
      <Select
        closeMenuOnSelect={false}
        closeMenuOnScroll={true}
        value={selectedOptions}
        isMulti={true}
        onChange={this.handleChange}
        options={this.options}
      />
    );
  }
}

const mapState = (state) => {
  return { list: state.admin.pacs.list };
};

const mapActions = (actions) => {
  return { listActions: actions.admin.pacs.list };
};

export default connect(useStore, mapState, mapActions)(ClientePacSelection);
